/* eslint-disable no-undef */
// eslint-disable-next-line import/prefer-default-export

const Event = async (eventName, ...args) => {
  console.log('[INFO] Firing MoEngage Event... ');
  if (typeof eventName === 'number') {
    Moengage.add_unique_user_id(eventName);
    return;
  }
  if (typeof args === 'object' && args.length > 0) {
    Moengage.track_event(eventName, args[0]);
    return;
  }
  if (eventName === 'Logout') {
    Moengage.destroy_session();
  }
  Moengage.track_event(eventName);
};

export default Event;
